import { useEffect, useState } from "react";
import { Input } from "@its-engineering-and-development/ui-foundation/components";
import { ConfirmDialog } from "@app/components/base/confirm-dialog";

const CONFIRMATION_WORD = "delete";

function isDeleteConfirmationMatch(value: string): boolean {
    return value.trim().toLowerCase() === CONFIRMATION_WORD;
}

export function DeleteCategoryDialog({
    isOpen,
    categoryName,
    isDeleting,
    onOpenChange,
    onConfirm,
}: {
    isOpen: boolean;
    categoryName: string;
    isDeleting: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => void | Promise<void>;
}) {
    const [confirmText, setConfirmText] = useState("");
    const isMatch = isDeleteConfirmationMatch(confirmText);

    // Clear on close so the next open (same or another category) starts empty.
    useEffect(() => {
        if (!isOpen) setConfirmText("");
    }, [isOpen]);

    return (
        <ConfirmDialog
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            title={`Delete "${categoryName}" permanently?`}
            confirmLabel="Delete category"
            isConfirming={isDeleting}
            isConfirmDisabled={!isMatch}
            onConfirm={onConfirm}
        >
            <p>
                Deleting this category removes it immediately from all expense dropdowns. Open expenses referencing this category must be recategorized before
                they can be submitted. This cannot be undone.
            </p>
            <p className="mt-3 font-medium text-gray-900">Type delete below to confirm.</p>
            <Input
                className="mt-2"
                aria-label="Type delete to confirm"
                autoFocus
                value={confirmText}
                onChange={setConfirmText}
                isDisabled={isDeleting}
                onKeyDown={(e) => {
                    if (e.key === "Enter" && isMatch && !isDeleting) {
                        e.preventDefault();
                        void onConfirm();
                    }
                }}
            />
        </ConfirmDialog>
    );
}
